module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section-padding blue-lt"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-5"
  }, [_c('p', [_vm._v("How many hours can your business go without accessing its critical systems or servers?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "recoveryTimeObjective",
      "max": "168",
      "value": _vm.recoveryTimeObjective
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2"
  }, [_c('p', [_vm._v("How many hours of production time on those servers are you willing to lose?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "recoveryPointObjective",
      "value": _vm.recoveryPointObjective,
      "max": "168"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding blue-dk"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 justify-content"
  }, [_c('p', [_vm._v("How many gigabytes of data are on your critical business systems? Critical systems are the systems essential to your business operations.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid-7"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "9999",
      "value": _vm.dataDisrupted,
      "label": "GB",
      "model": "dataDisrupted"
    },
    on: {
      "update-value": _vm.updateValue
    },
    model: {
      value: (_vm.dataDisrupted),
      callback: function($$v) {
        _vm.dataDisrupted = _vm._n($$v)
      },
      expression: "dataDisrupted"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 justify-content"
  }, [_c('p', [_vm._v("How often do you currently back up these systems, e.g. what is the time between each backup? ")]), _vm._v(" "), _c('input-time', {
    attrs: {
      "value": _vm.timeBetweenBackups,
      "model": "timeBetweenBackups"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 margin-top__lg"
  }, [_c('p', [_vm._v("How long does it take to initiate your recovery process? This is the amount of time that it will take you to prepare the systems for a recovery or restore.")]), _vm._v(" "), _c('input-time', {
    attrs: {
      "value": _vm.timeInitiateBackup,
      "model": "timeInitiateBackup"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 margin-top__lg"
  }, [_c('p', [_vm._v("Are you recovering data from a local network, or the cloud? This affects the speed at which the data can be recovered.")]), _vm._v(" "), _c('input-switch', {
    attrs: {
      "model": "recoverySpeed",
      "nameOne": "local",
      "nameTwo": "cloud",
      "labelOne": "Local",
      "labelTwo": "Cloud",
      "valueOne": "716800",
      "valueTwo": "30720"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding blue-lt"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "grid-5 justify-content"
  }, [_c('p', [_vm._v("How many employees would be affected if your critical systems failed?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "affectedEmployees",
      "value": _vm.affectedEmployees,
      "max": "1000"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 justify-content"
  }, [_c('p', [_vm._v("What is the revenue generated per hour by these employees?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "businessLost",
      "min": "0",
      "value": _vm.businessLost,
      "max": "10000",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 margin-top__lg justify-content"
  }, [_c('p', [_vm._v("What is the average hourly wage of an employee using one of your critical systems?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "averageWage",
      "value": _vm.averageWage,
      "max": "500",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 margin-top__lg justify-content"
  }, [_c('p', [_vm._v("What is the average hourly overhead cost of an employee using a critical system?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "overheadCost",
      "value": _vm.overheadCost,
      "min": "0",
      "max": "500",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('results', {
    attrs: {
      "recoveryTimeObjective": _vm.recoveryTimeObjective,
      "recoveryPointObjective": _vm.recoveryPointObjective,
      "dataDisrupted": _vm.dataDisrupted,
      "timeBetweenBackups": _vm.timeBetweenBackups,
      "timeInitiateBackup": _vm.timeInitiateBackup,
      "affectedEmployees": _vm.affectedEmployees,
      "averageWage": _vm.averageWage,
      "overheadCost": _vm.overheadCost,
      "businessLost": _vm.businessLost,
      "recoverySpeed": _vm.recoverySpeed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Set Your Recovery Objectives")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Recovery Process & Data Storage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Downtime & Recovery Costs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05586cd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calculator.vue
// module id = 30
// module chunks = 0